import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function getUtteranceFlags(requestObject, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.get("api/getUtteranceFlags", {
      params: { clientKey: requestObject, userKey },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function getUtteranceFlagsSelected(convID, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.get(`api/getUtteranceFlagsSelected/${convID}`, {
      params: { userKey },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function getUtteranceFlagsSummary(requestObject) {
  validateUserKey(requestObject.userKey);
  try {
    const { data } = await apiClient.get("api/getUtteranceFlagsSummary", {
      params: requestObject,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function createUtteranceFlagsSelected(requestData) {
  validateUserKey(requestData.UserKey);
  try {
    const { data } = await apiClient.post("api/createUtteranceFlagsSelected", requestData, {
      headers: {
        "x-user-key": requestData.UserKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function removeUtteranceFlagsSelected(requestData) {
  validateUserKey(requestData.UserKey);
  try {
    const { data } = await apiClient.patch("api/removeUtteranceFlagsSelected", requestData, {
      headers: {
        "x-user-key": requestData.UserKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function reviewUtteranceFlagsSelected(requestData) {
  validateUserKey(requestData.UserKey);
  try {
    const { data } = await apiClient.patch("api/reviewUtteranceFlagsSelected", requestData, {
      headers: {
        "x-user-key": requestData.UserKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
